import { VenueWriteContractError } from './venue-write-requests.js';
const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const id = value => typeof value === 'string' && /^[a-f0-9]{24}$/i.test(value);
export function readVenueIdentifier(value) {
  if (!id(value)) throw new VenueWriteContractError('identifier');
  return value;
}
export function readVenueListQuery(query = {}) {
  if (!record(query) || ['community', 'communityId'].some(field => query[field] != null && query[field] !== '' && !id(query[field]))
    || query.type != null && typeof query.type !== 'string') throw new VenueWriteContractError('list query');
  return query;
}
export function readVenueResourceQuery(query, preview = false) {
  if (!record(query) || typeof query.resourceType !== 'string' || !['session', 'event'].includes(query.resourceType.trim())
    || typeof query.resourceId !== 'string' || !id(query.resourceId.trim())
    || preview && (typeof query.venueId !== 'string' || !id(query.venueId.trim()))) throw new VenueWriteContractError('resource query');
  readVenueListQuery(query);
  return query;
}
const person = value => id(value) || record(value) && id(value.refId || value._id || value.id);
export function readVenueFindRequest(payload) {
  if (!record(payload) || ['facilitatorIds', 'participantIds'].some(field => payload[field] !== undefined && (!Array.isArray(payload[field]) || !payload[field].every(person)))
    || payload.userId !== undefined && !(Array.isArray(payload.userId) ? payload.userId.every(person) : person(payload.userId))) throw new VenueWriteContractError('related people');
  return payload;
}
